import { useEffect, useState } from 'react';
import throttle from 'lodash/throttle.js';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/pro-regular-svg-icons/faArrowUp';

export default function ScrollToTop() {
	const { y } = useScrollPosition();
	const visible = y > 600;
	
	const scrollToTop = () => {
		window.scroll({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});
	};
	
	const visibility_classes = visible
		? 'opacity-80 hover:opacity-100'
		: 'opacity-0 pointer-events-none';
	
	const testid = visible ? 'back-to-top-visible' : 'back-to-top-hidden';
	
	return (
		<div data-testid={ testid } className={ `fixed right-0 top-0 z-50 transition-opacity ${ visibility_classes }` }>
			<button
				onClick={ scrollToTop }
				className="inline-block py-3 px-6 mt-3 mr-3 text-white rounded-full shadow-lg cursor-pointer bg-blue font-condensed"
			>
				<Icon icon={ faArrowUp } className="mr-2" />
				Back to Top
			</button>
		</div>
	);
}

// Based on @rehooks/window-scroll-position
// But it had MSIE issues so I'm just replicating it here

let supportsPassive = false;

try {
	var opts = Object.defineProperty({}, 'passive', {
		get: function() {
			supportsPassive = true;
		},
	});
	window.addEventListener('testPassive', null, opts);
	window.removeEventListener('testPassive', null, opts);
} catch {
}

let getPosition = () => ({
	x: window.pageXOffset,
	y: window.pageYOffset,
});

function useScrollPosition(options = {}) {
	let opts = {
		throttle: 100,
		...options,
	};
	
	let [position, setPosition] = useState(getPosition());
	
	useEffect(() => {
		let handleScroll = throttle(() => {
			setPosition(getPosition());
		}, opts.throttle);
		
		window.addEventListener(
			'scroll',
			handleScroll,
			supportsPassive ? { passive: true } : false
		);
		
		return () => {
			handleScroll.cancel();
			window.removeEventListener('scroll', handleScroll);
		};
	}, [opts.throttle]);
	
	return position;
}
